module.exports = __webpack_public_path__ + "media/images/hash-doc-573fdf55c779cd05394c46fdfb3a1fca.svg";